import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const EventFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  onViewToggle, 
  currentView 
}) => {
  const eventTypeOptions = [
    { value: 'all', label: 'All Events' },
    { value: 'local', label: 'Local Events' },
    { value: 'virtual', label: 'Virtual Events' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'mindfulness', label: 'Mindfulness & Meditation' },
    { value: 'fitness', label: 'Fitness & Movement' },
    { value: 'nutrition', label: 'Nutrition & Wellness' },
    { value: 'mental-health', label: 'Mental Health' },
    { value: 'lifestyle', label: 'Lifestyle & Habits' },
    { value: 'community', label: 'Community Building' }
  ];

  const tierOptions = [
    { value: 'all', label: 'All Tiers' },
    { value: 'Intro', label: 'Intro' },
    { value: 'Flex', label: 'Flex' },
    { value: 'All Access', label: 'All Access' },
    { value: 'Premium', label: 'Premium' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Dates' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const hasActiveFilters = filters?.type !== 'all' || 
    filters?.category !== 'all' || 
    filters?.tier !== 'all' || 
    filters?.dateRange !== 'all' ||
    filters?.searchQuery?.length > 0;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="font-heading font-semibold text-foreground">Filters</h3>
          {hasActiveFilters && (
            <span className="px-2 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium">
              Active
            </span>
          )}
        </div>
        
        {/* View Toggle */}
        <div className="flex items-center space-x-2">
          <Button
            variant={currentView === 'grid' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onViewToggle('grid')}
          >
            <Icon name="Grid3X3" size={16} />
          </Button>
          <Button
            variant={currentView === 'list' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onViewToggle('list')}
          >
            <Icon name="List" size={16} />
          </Button>
          <Button
            variant={currentView === 'calendar' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onViewToggle('calendar')}
          >
            <Icon name="Calendar" size={16} />
          </Button>
        </div>
      </div>
      {/* Search */}
      <div className="mb-4">
        <Input
          type="search"
          placeholder="Search events, experts, or topics..."
          value={filters?.searchQuery}
          onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
          className="w-full"
        />
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Event Type"
          options={eventTypeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
        />

        <Select
          label="Category"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => onFilterChange('category', value)}
        />

        <Select
          label="Membership Tier"
          options={tierOptions}
          value={filters?.tier}
          onChange={(value) => onFilterChange('tier', value)}
        />

        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange('dateRange', value)}
        />
      </div>
      {/* Custom Date Range */}
      {filters?.dateRange === 'custom' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <Input
            type="date"
            label="Start Date"
            value={filters?.startDate}
            onChange={(e) => onFilterChange('startDate', e?.target?.value)}
          />
          <Input
            type="date"
            label="End Date"
            value={filters?.endDate}
            onChange={(e) => onFilterChange('endDate', e?.target?.value)}
          />
        </div>
      )}
      {/* Filter Actions */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <span className="text-sm text-muted-foreground">
            {filters?.resultCount} events found
          </span>
        </div>
        
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default EventFilters;